import React from 'react';
import '../css/ResetPassword.css';
import logoImg from '../public/logoQueruCume.png';

export default function ResetExpired() {
  const wrapperStyle = {
    background: '#2d2d2d',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    color: '#fff',
    textAlign: 'center',
  };

  return (
    <div style={wrapperStyle}>
      <img src={logoImg} alt="logo" style={{ width: 180, marginBottom: 20 }} />
      <div
        style={{
          backgroundColor: '#333',
          borderRadius: 16,
          padding: '40px 30px',
          boxShadow: '0 0 12px rgba(0,0,0,0.5)',
          maxWidth: 400,
        }}
      >
        <h2 style={{ color: '#ff5555', marginBottom: 16 }}>
          Link expirado ou já utilizado 
        </h2>
        <p style={{ color: '#ccc', marginBottom: 25 }}>
          O link de redefinição de senha expirou ou já foi usado.<br />
          Solicite um novo link.
        </p>
      </div>
    </div>
  );
}
